import { useCallback, useEffect, useState } from 'react';
import { Button as ButtonShad } from 'src/components/ui/button';
import { DialogFooter } from 'src/components/ui/dialog';
import { useAppSelector } from 'src/store';
import { ZendeskChatStep4 } from 'src/pages/ControlDeskPage/IntegrationStatusSection/IntegrationsModal/IntegrationModalStep4/ZendeskChatStep4/ZendeskChatStep4';
import { EmailReplySettingsStep } from 'src/pages/ControlDeskPage/IntegrationStatusSection/IntegrationsModal/EmailReplySettingsStep/EmailReplySettingsStep';
import { ZendeskEmailStep4 } from 'src/pages/ControlDeskPage/IntegrationStatusSection/IntegrationsModal/IntegrationModalStep4/ZendeskEmailStep4/ZendeskEmailStep4';
import type { SelectedIntegration } from 'src/store/slices/integrationSlice';

const NextIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
    <path
      d="M0 5.0625L6.84562 5.0625L3.70125 8.20688L4.5 9L9 4.5L4.5 -9.81574e-10L3.70687 0.793125L6.84562 3.9375L0 3.9375V5.0625Z"
      fill="white"
    />
  </svg>
);
export const IntegrationModalStep4 = ({
  defaultBtnStyle,
  onClick = () => {},
  close = () => {},
}: {
  defaultBtnStyle?: boolean;
  onClick?: (integration?: SelectedIntegration) => void;
  close?: (isFinal?: boolean) => void;
}) => {
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);
  const [formId, setFormId] = useState('integration-form');
  const isLastStep = selectedIntegration?.setupSteps === 4;

  useEffect(() => {
    if (selectedIntegration) {
      if (selectedIntegration.data.integration_type === 'zendesk_chat') {
        setFormId('auto-setup-form');
      }
      if (selectedIntegration.data.integration_type === 'zendesk_email') {
        setFormId('zendesk-email-step4-form');
      }
      if (selectedIntegration.data.integration_type === 'freshdesk_email') {
        setFormId('freshdesk-email-form');
      }
    }
  }, [selectedIntegration]);

  const renderStep4 = useCallback(() => {
    if (selectedIntegration) {
      switch (selectedIntegration.data.integration_type) {
        case 'zendesk_chat':
          return <ZendeskChatStep4 onClose={close} />;
        case 'zendesk_email':
          return <ZendeskEmailStep4 onClick={onClick} />;
        case 'freshdesk_email':
          return <EmailReplySettingsStep formId="freshdesk-email-form" onClose={close} />;
      }
    }
  }, [selectedIntegration]);

  return (
    <>
      {renderStep4()}
      <DialogFooter>
        {!defaultBtnStyle ? (
          <>
            <ButtonShad
              variant="pill-outline-dark"
              size="pill"
              style={{ width: 'auto', minWidth: '100px' }}
              onClick={() => close(isLastStep)}
            >
              Cancel
            </ButtonShad>
            <ButtonShad
              style={{ width: 'auto', minWidth: '100px' }}
              type="submit"
              form="integration-form"
              size="pill"
            >
              {isLastStep ? (
                'Launch'
              ) : (
                <>
                  Next <NextIcon />
                </>
              )}
            </ButtonShad>
          </>
        ) : (
          <div className="sticky bottom-0 w-full">
            <div className="flex w-full items-center justify-center gap-2.5 pb-6 pt-5">
              <ButtonShad
                type="button"
                variant="outline"
                className="transparent black min-w-28"
                onClick={() => close(isLastStep)}
              >
                {isLastStep ? 'Save & Close' : 'Cancel'}
              </ButtonShad>
              <ButtonShad type="submit" className="min-w-28 gap-1.5" form={formId}>
                {isLastStep ? (
                  'Launch'
                ) : (
                  <>
                    Next <NextIcon />
                  </>
                )}
              </ButtonShad>
            </div>
          </div>
        )}
      </DialogFooter>
    </>
  );
};
